<template>
  <div class="button-wrapper">
    <button @click="clickDeleteBtn">
      <Icons name="Delete" color="#5D3EBC" />
      Sil
    </button>
  </div>
</template>

<script setup>
import { Icons } from "@n11/so-ui-components";
import { useStore } from "vuex";

const props = defineProps({
  pid: {
    type: [String, Number],
    required: true,
  },
});

const store = useStore();

const clickDeleteBtn = () => {
  store.commit("products/SET_SINGLE_PRODUCT_DELETE_ROW_ID", props.pid);
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.button-wrapper {
  width: 30px;

  > button {
    color: $colorM50;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 2px;
  }
}
</style>
